import { render, staticRenderFns } from "./PaymentContact.vue?vue&type=template&id=3d49e0c6"
import script from "./PaymentContact.vue?vue&type=script&lang=js"
export * from "./PaymentContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports